import React, { useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Container, Divider, FormControl, FormLabel, Grid, InputLabel, MenuItem, Paper, Select, TextField, Theme, Typography, createStyles, makeStyles, colors, CircularProgress } from '@material-ui/core';
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { BladeModel } from '../app/utils/models';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { createNewModel, updateNewBladeModel, getBladeModelList, getBladeModels, removenewBladeModel, newProjectResponse } from "../app/reducer/bladeModal.reducer";
import { useAppSelector } from "../app/hooks";
import AlertComponent from "../components/general/Alert";
import { FanUploadProps } from './Fans'
import DeleteDialog from './DeleteDialog';
import Paths from '../utils/Paths';
import AlertDialog from './AlertDialog';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    radioGroup: {
      display: 'flex',
      flexDirection: 'row'
    },
    formControl: {
      width: '100%',
    },
    radioWrapped: {
      marginLeft: theme.spacing(2),
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    redOutline: {
      borderColor: "red !important"
    },
    uppercaseText: {
      textTransform: 'uppercase'
    }
  }),
);

interface LocationState {
  selectedValue?: string;
}

enum InputFieldsName {
  SelectBladeModelNumber,
  BladeWeight,
  BladeNaturalFrequencyM1,
  BladeType,
  BladeNaturalFrequencyM2,
  ShoulderCord,
  TipCord,
  TipAngleDeviation,
  Twist,
  BladeLength,
  BladeMaterial,
  BladeMinAngle,
  BladeMaxAngle
}

enum ButtonName {
  Edit,
  Duplicate,
  Delete,
  Submit,
  Back,
  PartialBack,
  PartialUpdate,
}
enum UserAction {
  View,
  Edit,
  Delete,
  Duplicate
}

const InputFieldsEnableConfig: any = {
  [UserAction.View]: [
    InputFieldsName.BladeWeight,
    InputFieldsName.BladeNaturalFrequencyM1,
    InputFieldsName.BladeType,
    InputFieldsName.BladeNaturalFrequencyM2,
    InputFieldsName.ShoulderCord,
    InputFieldsName.TipCord,
    InputFieldsName.TipAngleDeviation,
    InputFieldsName.Twist,
    InputFieldsName.BladeLength,
    InputFieldsName.BladeMaterial,
    InputFieldsName.BladeMinAngle,
    InputFieldsName.BladeMaxAngle
  ],
  [UserAction.Edit]: [InputFieldsName.SelectBladeModelNumber],
  [UserAction.Duplicate]: [],
  [UserAction.Delete]: [],
}

const ButtonVisibleConfig = {
  [UserAction.View]: [ButtonName.Edit, ButtonName.Delete, ButtonName.Duplicate, ButtonName.Back, ButtonName.PartialUpdate],
  [UserAction.Edit]: [ButtonName.Submit, ButtonName.PartialBack],
  [UserAction.Duplicate]: [ButtonName.PartialBack, ButtonName.Submit],
  [UserAction.Delete]: [ButtonName.Edit, ButtonName.Delete, ButtonName.Duplicate, ButtonName.Back]
}


const BladeModels: React.FC<FanUploadProps> = ({ setIndex, modelId, setVisibleModule, isFromFanList, footerDisable }: FanUploadProps) => {

  const { register, handleSubmit, setValue, getValues, control, formState: { errors }, setError, reset } = useForm<BladeModel>();
  const classes = useStyles();
  const dispatch = useDispatch()
  const history = useHistory();
  const location = useLocation<LocationState>();
  const { selectedValue } = location.state || {};

  const [value, setSelectedValue] = useState<string | null>(null);
  const [inputValue, setInputValue] = useState('');
  const [bladeModels, setBladeModels] = useState<any[] | undefined>([]);
  const newProjectResponses = useAppSelector(newProjectResponse);
  const [options, setOptions] = useState<string[]>([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [buttonAction, setButtonAction] = useState<string>('Edit');
  const [openAlert, setOpenAlert] = React.useState<boolean>(false);
  const [openAlertMesage, setOpenAlertMessage] = React.useState<string>("");
  const [userAction, setUserAction] = React.useState<UserAction>(UserAction.View);
  const [modelIdList, setModelIdList] = React.useState<string[]>([]);
  const [duplicateBandId, setDuplicateBandId] = useState("");
  const [warningDialog, setWarningDialog] = useState(false);
  const [warningDialogText, setWarningDialogText] = useState("");
  const [loading, setLoading] = useState(false);

  const cache: any = {};
  const memoizedGetBladeModels = async () => {
    if (cache.bladeModels) {
      return cache.bladeModels;
    }
    const bladeModels = await dispatch(getBladeModels());
    cache.bladeModels = bladeModels;

    return bladeModels;
  };

  const fetchUpdatedData = async () => {
    const bladeModels = await memoizedGetBladeModels();
    const modelList = bladeModels.payload.data
    setBladeModels(modelList)
    const options = modelList ? modelList.map((item: any) => item?.bladeModelID) : [];
    setModelIdList(options.sort());
    setOptions(options.sort())
  }

  useEffect(() => {
    (async () => {
      setLoading(true);
      if (setIndex) {
        setIndex(1);
      }
      await fetchUpdatedData(); // Wait for fetchUpdatedData to complete
      let inputValue = ''
      if (selectedValue) {
        inputValue = selectedValue
      }
      if (modelId) {
        inputValue = modelId;
      }
      if (inputValue) {
        setSelectedValue(inputValue);
        const { newValues, selectedItem } = updateNewValues(inputValue);
        Object.keys(newValues).forEach((fieldName: any) => {
          setValue(fieldName, selectedItem[fieldName]);
        });
      }
      setLoading(false);
    })();
  }, []);


  const updateNewValues = (inputValue: any) => {

    const selectedItem = bladeModels && bladeModels?.find(item => item.bladeModelID == inputValue)
    console.log({
      bladeModels: bladeModels,
      selectedItem: selectedItem
    })
    if (!bladeModels?.length || !selectedItem) {
      return { newValues: {}, selectedItem: {} };
    }
    const newValues: any = {
      bladeModelID: selectedItem.bladeModelID,
      bladeWeight: selectedItem.bladeWeight,
      bladeFreqMode1: selectedItem.bladeFreqMode1,
      bladeType: selectedItem.bladeType,
      bladeFreqMode2: selectedItem.bladeFreqMode2,
      shoulderChord: selectedItem.shoulderChord,
      tipChord: selectedItem.tipChord,
      tipAngleDeviation: selectedItem.tipAngleDeviation,
      twist: selectedItem.twist,
      bladeLength: selectedItem.bladeLength,
      bladeMaterial: selectedItem.bladeMaterial,
      bladeMinAngle: selectedItem.bladeMinAngle,
      bladeMaxAngle: selectedItem.bladeMaxAngle
    };
    return { newValues: newValues, selectedItem: selectedItem };
  }


  const handleAddNewItem = () => {
    if (inputValue.trim() && !options.includes(inputValue)) {
      setOptions([...options, inputValue]);
      setSelectedValue(inputValue);
    }
    if (options.length == 0) {
      fetchUpdatedData();
    }
  };

  const onSubmit: SubmitHandler<BladeModel> = async data => {
    let newData = { ...data, bladeModelID: inputValue };
    if (buttonAction == "Duplicate" && modelIdList.includes(inputValue))
      return;
    if (newData.bladeModelID != "") {
      if (buttonAction == "Edit") {
        await dispatch(updateNewBladeModel(newData));
        setOpenAlertMessage('Blade Model data updated successfully')
        reset();
        setSelectedValue('');
      } else {
        await dispatch(createNewModel(newData));
        if (!newProjectResponses) {
          setOpenAlertMessage('New Model created successfully');
          reset();
          setSelectedValue('');
        }

      }
      setOpenAlert(true);
    }
  };

  const refresh = () => {
    enableParentFooter();
    fetchUpdatedData();
    history.go(0);
  }

  const onInputChange = (event: any, newInputValue: any, reason: string) => {
    if (reason === "clear")
      reset();
    setInputValue(newInputValue);
    // if (setVisibleModule) {
    //   setVisibleModule(newInputValue);
    // }
    if (!bladeModels && !inputValue) {
      return false;
    }
    const { newValues, selectedItem } = updateNewValues(newInputValue)
    Object.keys(newValues).forEach((fieldName: any) => {
      setValue(fieldName, selectedItem[fieldName]);
    });
  }

  const editField = () => {
    if (inputValue.length <= 0) {
      setWarningDialog(true);
      setWarningDialogText("Please select a Blade Model Number for edit.")
      return;
    }
    setUserAction(UserAction.Edit);
    /*if(modelId){
      history.push('/blade-models',{selectedValue:inputValue})
    }*/
    disableParentFooter();
    setButtonAction("Edit");
    if (!bladeModels && !inputValue) {
      return false;
    }
    setDuplicateBandId(inputValue);
    const { newValues, selectedItem } = updateNewValues(inputValue)
    Object.keys(newValues).forEach((fieldName: any) => {
      setValue(fieldName, selectedItem[fieldName]);
    });
  }

  const duplicateField = () => {
    if (inputValue.length <= 0) {
      setWarningDialog(true);
      setWarningDialogText("Please select a Blade Model Number to duplicate.")
      return;
    }
    setUserAction(UserAction.Duplicate);
    setButtonAction("Duplicate");
    if (!bladeModels && !inputValue) {
      return false
    }
    setDuplicateBandId(inputValue);
    const { newValues, selectedItem } = updateNewValues(inputValue)
    Object.keys(newValues).forEach((fieldName: any) => {
      setValue(fieldName, selectedItem[fieldName]);
    });
  }


  function disableParentFooter() {
    if (isFromFanList)
      footerDisable(true)
  }

  function enableParentFooter() {
    if (isFromFanList)
      footerDisable(false)
  }


  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    if (inputValue === null || inputValue === undefined || inputValue === "") {
      setWarningDialog(true);
      setWarningDialogText("Please select a Blade Model Number for deletion.")
      return;
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    handleClose();
    setOpenAlertMessage('Deleted Model successfully');
    setOpenAlert(true);
  };

  const onDelete = async () => {
    setButtonAction("Delete");
    if (!bladeModels && !inputValue) {
      return false
    }
    const { newValues, selectedItem } = updateNewValues(inputValue)
    Object.keys(newValues).forEach((fieldName: any) => {
      setValue(fieldName, selectedItem[fieldName]);
    });
    await dispatch(removenewBladeModel(newValues));
    setOpenAlertMessage('Deleted Model successfully');
    setOpenAlert(true);
  }

  const isTexFieldEnable = (name: InputFieldsName): boolean => {
    return InputFieldsEnableConfig[userAction].includes(name);
  }

  const isButtonVisible = (name: ButtonName): boolean => {
    return ButtonVisibleConfig[userAction].includes(name);
  }

  const isPartialButtonVissible = (): any => {
    return isFromFanList && isButtonVisible(ButtonName.PartialUpdate);
  }

  const onPartialUpdate = () => {
    if (setVisibleModule && inputValue) {
      setVisibleModule(inputValue);
      setWarningDialog(true);
      setWarningDialogText("New Blade Model Updated.")
    }
  }

  return (
    <div className="page-wrapper">
      <Container maxWidth="xl">
        <Paper className="form-wrapper">
          <Typography variant="h5" gutterBottom>
            <b className={classes.uppercaseText}> {buttonAction} Blade Model Details</b>
          </Typography>
          <hr />
          <Divider />
          <AlertDialog open={warningDialog} message={warningDialogText} handleClose={() => setWarningDialog(false)} />
          <DeleteDialog open={open} handleClose={handleClose} path={Paths.BladeModel} idType="bladeModelID" id={inputValue} handleDelete={handleDelete} />
          <AlertDialog open={openAlert} message={openAlertMesage} handleClose={() => { setOpenAlert(false); refresh(); }} />
          {/* <AlertComponent open={openAlert} message={openAlertMesage} severity="success" handleClose={() => { setOpenAlert(false) }} /> */}

          <form id="fan-details-form" style={{ padding: '5px' }} onSubmit={handleSubmit(onSubmit)}>
            {(!inputValue || modelIdList.includes(inputValue)) && (buttonAction == 'Duplicate') && (
              <p className="MuiFormHelperText-root MuiFormHelperText-contained" style={{ color: 'red' }}>Add new model number</p>
            )}
            {inputValue && buttonAction == 'Duplicate' && newProjectResponses?.error?.errors[0].bladeModel && (
              <p className="MuiFormHelperText-root MuiFormHelperText-contained" style={{ color: 'red' }}>{newProjectResponses?.error?.errors[0].bladeModel}</p>
            )}


            <Grid container spacing={3}>
              <Grid item xs={12} lg={3}>
                <Autocomplete
                  disabled={isTexFieldEnable(InputFieldsName.SelectBladeModelNumber)}
                  value={value}
                  inputValue={inputValue}
                  onInputChange={onInputChange}
                  options={options}
                  freeSolo
                  renderInput={(params: any) => (
                    <TextField

                      {...params}
                      label="Select or add new Blade Model Number"
                      InputLabelProps={{
                        style: { fontSize: 14 }
                      }}
                      variant="outlined"
                    />
                  )}

                  onBlur={handleAddNewItem}
                  onKeyDown={(event: any) => {
                    if (event.key === 'Enter') {
                      handleAddNewItem();
                    }
                  }}
                />
              </Grid>
              {isButtonVisible(ButtonName.Edit) && (
                <Grid item xs={12} lg={2}>
                  <Button variant="contained" color="primary" onClick={editField} style={{ width: '180px', backgroundColor: '#10B981' }}>EDIT BLADE</Button>
                </Grid>)
              }
              {
                (modelId && isButtonVisible(ButtonName.Submit)) && (
                  <Grid item xs={12} lg={2}>
                    <Button variant="contained" color="primary" type='submit'>{buttonAction} Submit</Button>
                  </Grid>
                )
              }
              {isPartialButtonVissible() && (
                <Grid item xs={12} lg={2}>
                  <Button variant="contained" style={{ color: 'white' }} color="secondary" type='button' onClick={onPartialUpdate}>Update</Button>
                </Grid>)
              }
              {
                isButtonVisible(ButtonName.PartialBack) && (
                  <Grid item xs={12} lg={2}>
                    <Button variant="contained" color="primary" onClick={() => {
                      if (userAction === UserAction.Duplicate) {
                        setInputValue(duplicateBandId);
                        onInputChange(null, duplicateBandId, "REFRESH")
                      }
                      if (userAction === UserAction.Edit) {
                        onInputChange(null, duplicateBandId, "REFRESH")
                      }
                      setUserAction(UserAction.View)
                      setButtonAction('Edit')
                      enableParentFooter();
                    }} style={{ width: '180px', backgroundColor: '#41bb98' }}>Back</Button>
                  </Grid>)
              }
              {
                // Enable only if - it's a sub screen.
              }
              {(!modelId && !isFromFanList) && (
                <>
                  {isButtonVisible(ButtonName.Duplicate) &&
                    <Grid item xs={12} lg={2}>
                      <Button variant="contained" color="secondary" style={{ color: 'white', backgroundColor: 'rgb(245 154 36)' }} onClick={duplicateField}>DUPLICATE BLADE</Button>
                    </Grid>
                  }
                  {isButtonVisible(ButtonName.Delete) &&
                    <Grid item xs={12} lg={2}>
                      <Button variant="contained" color="secondary" style={{ color: 'white', backgroundColor: 'rgba(217, 0, 27, 1)' }} onClick={handleOpen}>DELETE BLADE</Button>
                    </Grid>
                  }
                </>)
              }
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true,style:{fontSize:'22px'}  }}
                  disabled={isTexFieldEnable(InputFieldsName.BladeWeight)}
                  label="Blade Weight (kg)"
                  variant="outlined" fullWidth
                  {...register("bladeWeight", { required: true })}
                  helperText={errors.bladeWeight ? 'This field is required' : ''}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true,style:{fontSize:'22px'} }}
                  disabled={isTexFieldEnable(InputFieldsName.BladeNaturalFrequencyM1)}
                  label="Blade Natural Freq.M1 (Hz)"
                  variant="outlined" fullWidth
                  {...register("bladeFreqMode1", { required: true })}
                  helperText={errors.bladeWeight ? 'This field is required' : ''}
                />
              </Grid>
              <Grid item xs={12} lg={3}>

                <FormControl variant="outlined" className={classes.formControl} >
                  <InputLabel style={{fontSize:'22px'}}  variant="outlined">Blade Type</InputLabel>
                  <Controller
                    control={control}
                    name="bladeType"
                    defaultValue="axial"
                    render={({ field: { onChange, value } }) => (
                      <Select
                        label="Blade Type"
                        value={value}
                        {...register("bladeType", { required: true })}
                        disabled={isTexFieldEnable(InputFieldsName.BladeType)}
                      >
                        <MenuItem value="C-type">C-type</MenuItem>
                        <MenuItem value="U-Type">U-Type</MenuItem>
                        <MenuItem value="V-Type">V-Type</MenuItem>
                      </Select>
                    )}

                  />
                </FormControl>

              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true,style:{fontSize:'22px'}  }}
                  disabled={isTexFieldEnable(InputFieldsName.BladeNaturalFrequencyM2)}
                  label="Blade Natural  Freq M2(Hz)"
                  variant="outlined" fullWidth
                  {...register("bladeFreqMode2", { required: true })}
                  helperText={errors.bladeWeight ? 'This field is required' : ''}
                />

              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true ,style:{fontSize:'22px'} }}
                  disabled={isTexFieldEnable(InputFieldsName.ShoulderCord)}
                  label="Shoulder Cord (mm)"
                  variant="outlined" fullWidth
                  {...register("shoulderChord", { required: true })}
                  helperText={errors.bladeWeight ? 'This field is required' : ''}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true,style:{fontSize:'22px'}  }}
                  disabled={isTexFieldEnable(InputFieldsName.TipCord)}
                  label="Tip Cord (mm)"
                  variant="outlined" fullWidth
                  {...register("tipChord", { required: true })}
                  helperText={errors.bladeWeight ? 'This field is required' : ''}
                />
              </Grid>

              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true,style:{fontSize:'22px'}  }}
                  disabled={isTexFieldEnable(InputFieldsName.TipAngleDeviation)}
                  label="Tip Angle Deviation From Cord (°)"
                  variant="outlined" fullWidth
                  {...register("tipAngleDeviation", { required: true })}
                  helperText={errors.bladeWeight ? 'This field is required' : ''}
                />
              </Grid>

              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true ,style:{fontSize:'22px'} }}
                  disabled={isTexFieldEnable(InputFieldsName.Twist)}
                  label="Twist (°)"
                  variant="outlined" fullWidth
                  {...register("twist", { required: true })}
                  helperText={errors.bladeWeight ? 'This field is required' : ''}
                />
              </Grid>

              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true,style:{fontSize:'22px'}  }}
                  disabled={isTexFieldEnable(InputFieldsName.BladeLength)}
                  label="Blade Length (mm)"
                  variant="outlined" fullWidth
                  {...register("bladeLength", { required: true })}
                  helperText={errors.bladeWeight ? 'This field is required' : ''}
                />
              </Grid>

              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true,style:{fontSize:'22px'}  }}
                  disabled={isTexFieldEnable(InputFieldsName.BladeMaterial)}
                  label="Blade Material"
                  variant="outlined" fullWidth
                  {...register("bladeMaterial", { required: true })}
                  helperText={errors.bladeWeight ? 'This field is required' : ''}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true,style:{fontSize:'22px'}  }}
                  disabled={isTexFieldEnable(InputFieldsName.BladeMinAngle)}
                  label="Blade Min Angle (°)"
                  variant="outlined" fullWidth
                  {...register("bladeMinAngle", { required: true })}
                  helperText={errors.bladeWeight ? 'This field is required' : ''}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true,style:{fontSize:'22px'}  }}
                  label="Blade Max Angle (°)"
                  disabled={isTexFieldEnable(InputFieldsName.BladeMaxAngle)}
                  variant="outlined" fullWidth
                  {...register("bladeMaxAngle", { required: true })}
                  helperText={errors.bladeWeight ? 'This field is required' : ''}
                />
              </Grid>

            </Grid>
            {!modelId &&
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                {isButtonVisible(ButtonName.Submit) &&
                  <Grid item xs={12} lg={12}>
                    <Button variant="contained" color="primary" type='submit'>{buttonAction} Submit</Button>
                  </Grid>
                }
                {(!isFromFanList && isButtonVisible(ButtonName.Back)) &&
                  <Grid item xs={12} lg={12}>
                    <Button style={{ color: 'white', backgroundColor: '#EF4444' }} variant="contained" type='button' onClick={() => history.goBack()}>Back</Button>
                  </Grid>
                }
              </Grid>
            }
          </form>
        </Paper>

        <Dialog open={loading} aria-labelledby="delete-dialog-title">
          <DialogContent>
            <CircularProgress />
          </DialogContent>
        </Dialog>

      </Container>
    </div>
  );

}

export default BladeModels;

